import { render, staticRenderFns } from "./loginAuth.vue?vue&type=template&id=1a8fc161&scoped=true&"
import script from "./loginAuth.vue?vue&type=script&lang=js&"
export * from "./loginAuth.vue?vue&type=script&lang=js&"
import style0 from "./loginAuth.vue?vue&type=style&index=0&id=1a8fc161&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8fc161",
  null
  
)

export default component.exports